import { ROLE_TYPE } from "@/constants";
import accountRoutes from "./account";
import exchangeRoutes from "./Exchange";
import receiptRoutes from "./receipt";
import siteServiceRoutes from "./siteService";
import specialSaleRoutes from "./specialSale";
import subscribeServiceRoutes from "./subscribeService";
import { Routes } from "./utils/renderRoutes";
import { lazy } from 'react';
import { MENU, MENU_MAP } from "@/constants/menu";
import { getPath, MAKE_SERVICE, MAKE_SERVICE_MAP } from "../SubscribeService/constants";
import { upperCap } from "@/utils";

export const errorRoutes: Routes[] = [
    {
        title: '404',
        path: '/404',
        component: lazy(() => import('@/views/_404')),
    },
    {
        redirect: true,
        from: '*',
        to: '/404',
    }
];

/**
 * 全部路由
 */
const allRoutes: Routes[] = [
    ...accountRoutes,
    ...receiptRoutes,
    ...subscribeServiceRoutes,
    ...siteServiceRoutes,
    ...exchangeRoutes,
    ...specialSaleRoutes,
    {
        exact: true,
        redirect: true,
        from: '/',
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
    {
        redirect: true,
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
    // ...errorRoutes,
];

/**
 * GE领班权限路由
 * - M1 客户账户：会员升降级、邀请成为奕尚  不可访问
 * - M3 预约服务：服务余量设置 不可访问
 * - M7 Iguru
 */
const gangerRoutes: Routes[] = [
    ...accountRoutes,
    ...receiptRoutes,
    ...subscribeServiceRoutes.map(route => {
        if (route.path === `/${MENU.SUBSCRIBE_SERVICE}`) {
            return {
                ...route,
                children: route.children.filter(route => route.path !== getPath(MAKE_SERVICE.MARGIN))
            }
        }
        return route;
    }),
    ...siteServiceRoutes,
    ...exchangeRoutes,
    ...specialSaleRoutes,
    {
        exact: true,
        redirect: true,
        from: '/',
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
    {
        redirect: true,
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
];

/**
 * GE迎宾大使权限路由
 * - M1 客户账户：会员升降级、邀请成为奕尚、快捷服务-优惠停车
 * - M3 预约服务：服务余量设置 不可访问
 * - M7 Iguru
 */
const ambassadorRoutes: Routes[] = [
    ...accountRoutes.map(route => {
        if (route.path === `/${MENU.CUSTOMER_ACCOUNT}`) {
            return {
                ...route,
                children: route.children.filter(route => route.path !== `/${MENU.CUSTOMER_ACCOUNT}/quick`)
            }
        }
        return route;
    }),
    ...receiptRoutes,
    ...subscribeServiceRoutes.map(route => {
        if (route.path === `/${MENU.SUBSCRIBE_SERVICE}`) {
            return {
                ...route,
                children: route.children.filter(route => route.path !== getPath(MAKE_SERVICE.MARGIN))
            }
        }
        return route;
    }),
    ...siteServiceRoutes,
    ...exchangeRoutes,
    ...specialSaleRoutes,
    {
        exact: true,
        redirect: true,
        from: '/',
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
    {
        redirect: true,
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
];

/**
 * GE兼职权限路由
 * - M1 客户账户：只有客户列表
 * - M2 小票管理：上传小票、搜索历史小票
 * - M6 特卖入场:DIGITAL Q 可以访问
 */
const ptRoutes: Routes[] = [
    {
        title: MENU_MAP[MENU.CUSTOMER_ACCOUNT],
        path: `/${MENU.CUSTOMER_ACCOUNT}`,
        component: lazy(() => import('@/views/CustomerAccount')),
        children: [
            {
                title: '客户账户',
                path: '/customer-account/list',
                component: lazy(() => import('@/views/CustomerAccount/List')),
            },
            {
                redirect: true,
                from: '/customer-account',
                to: '/customer-account/list',
            },
        ]
    },
    ...receiptRoutes,
    ...specialSaleRoutes,
    {
        exact: true,
        redirect: true,
        from: '/',
        to: `/${MENU.RECEIPT}`,
    },
    {
        redirect: true,
        to: `/${MENU.RECEIPT}`,
    },
];

/**
 * OPS安保权限路由
 * - M3 预约服务：代客泊车入场 可以访问
 */
const opsRoutes: Routes[] = [
    {
        title: MENU_MAP[MENU.SUBSCRIBE_SERVICE],
        path: `/${MENU.SUBSCRIBE_SERVICE}`,
        component: lazy(() => import('@/views/SubscribeService')),
        children: [
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.PARKING],
                path: getPath(MAKE_SERVICE.PARKING),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.PARKING)}`))
            },
            {
                redirect: true,
                from: `/${MENU.SUBSCRIBE_SERVICE}`,
                to: getPath(MAKE_SERVICE.PARKING),
            },
        ]
    },
    {
        exact: true,
        redirect: true,
        from: '/',
        to: `/${MENU.SUBSCRIBE_SERVICE}`,
    },
    {
        redirect: true,
        to: `/${MENU.SUBSCRIBE_SERVICE}`,
    },
];

/**
 * DRT导购大使权限路由
 * - M1 客户账户
 * - M2 小票管理
 * - M3 预约服务：预约服务审核 可以访问
 * - M6 特卖入场
 * - M7 Iguru
 */
const drtRoutes: Routes[] = [
    ...accountRoutes,
    ...receiptRoutes,
    {
        title: MENU_MAP[MENU.SUBSCRIBE_SERVICE],
        path: `/${MENU.SUBSCRIBE_SERVICE}`,
        component: lazy(() => import('@/views/SubscribeService')),
        children: [
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.MANAGE],
                path: getPath(MAKE_SERVICE.MANAGE),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.MANAGE)}`))
            },
            {
                redirect: true,
                from: `/${MENU.SUBSCRIBE_SERVICE}`,
                to: getPath(MAKE_SERVICE.MANAGE),
            },
        ]
    },
    ...specialSaleRoutes,
    {
        exact: true,
        redirect: true,
        from: '/',
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
    {
        redirect: true,
        to: `/${MENU.CUSTOMER_ACCOUNT}`,
    },
];

/**
 * 角色对应路由
 * GE经理(Manager) all
 * GE领班(Ganger) M1 客户账户：会员升降级、邀请成为奕尚；M3 预约服务：服务余量设置 不可访问
 * GE迎宾大使(Ambassador) M1 客户账户：会员升降级、邀请成为奕尚、快捷服务-优惠停车；M3 预约服务：服务余量设置 不可访问
 * GE兼职(PT)  M2 小票管理：上传小票、搜索历史小票；M6 特卖入场:DIGITAL Q 可以访问
 * OPS安保 M3 预约服务：代客泊车入场 可以访问
 * DRT导购大使 M1 客户账户；M2 小票管理；M3 预约服务：预约服务审核 可以访问；M6 特卖入场:DIGITAL Q 可以访问；M7 Iguru 可以访问
 */
export const roleRouters = {
    [ROLE_TYPE.MANAGER]: allRoutes,
    [ROLE_TYPE.GANGER]: gangerRoutes,
    [ROLE_TYPE.AMBASSADOR]: ambassadorRoutes,
    [ROLE_TYPE.PT]: ptRoutes,
    [ROLE_TYPE.OPS]: opsRoutes,
    [ROLE_TYPE.DRT]: drtRoutes,
};